import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  HostBinding,
  Injector,
  Input,
  OnInit,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true,
    },
  ],
})
export class TextareaComponent implements ControlValueAccessor, OnInit {
  @Input() title!: string;
  @Input() placeholder: string = '';
  @Input() type: string = 'text';
  @Input() clearable: boolean = false;
  @Input() disabled: boolean = false;
  @Input() currency: boolean = false;
  public value: string | null = '';
  public control!: NgControl;

  constructor(private cdRef: ChangeDetectorRef, private injector: Injector) {}

  @HostBinding('class.has-error') get class() {
    return this.control.touched && !!this.control.errors;
  }

  public ngOnInit() {
    this.control = this.injector.get(NgControl);
  }

  private onChange: any = () => {};
  public onTouch: any = () => {};

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public writeValue(checked: string) {
    this.value = checked;
    this.cdRef.detectChanges();
  }

  public onModelChange(e: string) {
    this.value = e;
    this.onChange(e);
  }

  public onClear(): void {
    this.value = null;
    this.onChange(null);
  }
}
